import loadable from '@loadable/component';

// 懒加载组件
const SupInfoMaintenance = loadable(() => import('./supInfoMaintenance/SupInfoMaintenance'));
const UserManagement = loadable(() => import('./userManagement/UserManagement'));

export const subRoutes = [
  {
    path: '/SupInfoMaintenance',
    component: SupInfoMaintenance
  },
  {
    // 供应商用户维护
    path: '/UserManagement',
    component: UserManagement
  }
];
